var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"loading-container",class:_vm.containerClass},[_c('div',{staticClass:"loading-spinner",class:_vm.spinnerClass},[_c('div',{staticClass:"spinner-ring"}),_c('div',{staticClass:"spinner-ring"}),_c('div',{staticClass:"spinner-ring"})]),(_vm.text)?_c('p',{staticClass:"loading-text"},[_vm._v(_vm._s(_vm.text))]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }